import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNotAStringErrorMessage = (
  <Trans>
    Ce champ doit contenir du texte
  </Trans>
);
